import React from "react";
import { Link } from "react-router-dom";
import { LogoFullColor } from "../assets/assets";

export default function Page404() {
  return (
    <>
      <div className="">
        <div className="grid grid-cols-1 h-screen md:grid-cols-3">
          <div className=" bg-cover-E404 bg-secondary-500">
            <div className="absolute top-5 left-5">
              <LogoFullColor className="h-10 lg:h-14" />
            </div>
            <div className="h-full"></div>
          </div>
          <div className="col-span-2 items-center">
            <div className="flex items-center h-full bg-gray-100">
              <div className="container mx-auto px-12  ">
                <div className="max-w-3xl">
                  <div className="my-6 lg:my-1 container px-6 mx-auto flex flex-col items-start justify-between pb-4 border-b border-gray-300  ">
                    <h4 className="text-3xl font-bold leading-tight text-secondary">
                      404: Page Not Found
                    </h4>
                  </div>

                  <form action="#" method="POST">
                    <div className="overflow-hidden sm:rounded-md">
                      <p className="px-6 text-lg font-medium text-gray-700">
                        The page you are looking for does not exist. How you got
                        here is a mystrey. But you can click the botton below to
                        go back to the homepage.
                      </p>
                      <div className="flex justify-between">
                        <div className="px-3 py-3 text-right sm:px-6">
                          <Link
                            to="https://www.psikku.com"
                            className="btn-primary"
                          >
                            Back to Psikku
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
